module.exports = __webpack_public_path__ + "static/media/coin_lumi.b9211cdb.svg";